import { createStore, applyMiddleware } from 'redux';
import { rootReducer } from './reducers';
import { apiMiddleware } from './apiMiddleware';
import { cryptoproMiddleware } from './cryptoproMiddleware';

export const store = createStore(rootReducer, applyMiddleware(apiMiddleware, cryptoproMiddleware));